"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../../01_atoms/Button"));

var _Bottom = _interopRequireDefault(require("../../01_atoms/Bottom"));

var _Container = _interopRequireDefault(require("../../01_atoms/Container"));

var _Element = _interopRequireDefault(require("../../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../../01_atoms/ElementGroup"));

var _LoadingPlaceHolder = _interopRequireDefault(require("../../01_atoms/LoadingPlaceHolder"));

var _Spacer = _interopRequireDefault(require("../../01_atoms/Spacer"));

var _PopupScreen = _interopRequireDefault(require("../../02_molecules/PopupScreen"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GenericStopsPageUI = function GenericStopsPageUI(_ref) {
  var loading = _ref.loading,
      ticket = _ref.ticket,
      stops = _ref.stops,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('GenericStopsPageUI');
  var content = null;

  if (loading) {
    content = /*#__PURE__*/_react["default"].createElement(_LoadingPlaceHolder["default"], null);
  } else {
    stops.sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
    content = /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
      title: t('Route used by this bus'),
      subtitle: t("This bus passes through all these cities. It doesn't necessarily stops there.")
    }, stops.map(function (s) {
      return /*#__PURE__*/_react["default"].createElement(_Element["default"], {
        key: "ticket-stop_".concat(ticket.id, "_").concat(s.name)
      }, s.name);
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_PopupScreen["default"], {
    title: t('Bus route'),
    onBack: onBack
  }, content, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], null), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onBack,
    fluid: true
  }, t('Back')))));
};

var _default = GenericStopsPageUI;
exports["default"] = _default;